// Código del Generador de links (?ref=) guardado en el navegador hasta que la
// persona crea su cuenta. Vence a los 30 días: si alguien abrió un link hace
// mucho y se registra después por su cuenta, no se le atribuye a ese link.
// Lo usan el router (guardar al llegar con ?ref) y el store (register y
// googleLogin lo mandan como referral_code y lo limpian al crear la cuenta).
const CLAVE = 'referral_code';
const CLAVE_FECHA = 'referral_code_at';
const VIGENCIA_MS = 30 * 24 * 60 * 60 * 1000;

export function guardarReferido(codigo) {
    try {
        localStorage.setItem(CLAVE, String(codigo));
        localStorage.setItem(CLAVE_FECHA, String(Date.now()));
    } catch (e) {
        console.warn('No se pudo guardar referral_code en localStorage', e);
    }
}

export function limpiarReferido() {
    try {
        localStorage.removeItem(CLAVE);
        localStorage.removeItem(CLAVE_FECHA);
    } catch (e) { /* sin localStorage no hay nada que limpiar */ }
}

// Devuelve el código vigente o null. Los guardados antes de este cambio no
// tienen fecha: se toman como de hoy (se les pone la fecha ahora).
export function leerReferido() {
    try {
        const codigo = localStorage.getItem(CLAVE);
        if (!codigo) return null;
        const fecha = Number(localStorage.getItem(CLAVE_FECHA));
        if (!fecha) {
            localStorage.setItem(CLAVE_FECHA, String(Date.now()));
            return codigo;
        }
        if (Date.now() - fecha > VIGENCIA_MS) {
            limpiarReferido();
            return null;
        }
        return codigo;
    } catch (e) {
        console.warn('No se pudo leer referral_code desde localStorage');
        return null;
    }
}
